export default "__VITE_ASSET__BKcWVrgH__"